import deepenChildren from '@iez/lib/deepen-children/'

export default ({ items }) => ({
  objects: items.map(item => ({
    ...deepenChildren(item)
  }))
})
